/** @format */

const template = `
<div class="accordion-panel {{$ctrl.specialExpandableClass}}">
  <div class="header">
    <a
      id="{{$ctrl.headingId}}"
      href
      class="collapse"
      ng-click="$ctrl.toggleContent()"
      ng-class="{collapsed: $ctrl.collapsed}"
      ng-disabled="!$ctrl.toggleButtonEnabled()"
      role="button"
      data-cy="expandable-toggle"
      aria-label="{{::'ARIA_LABEL.EXPAND' | translate}} {{$ctrl.expandableTitle}}"
      aria-expanded="{{!$ctrl.collapsed}}">
      <sis-icon [icon]="'chevron-ring-fill'" [icon-class]="$ctrl.collapsed ? null : 'cw-90'"></sis-icon
    ></a>
    <div class="title">
      <transpile [content]="$ctrl.expandableTitle" />
    </div>
  </div>
  <div
    ng-class="{'collapsed': $ctrl.collapsed}"
    aria-hidden="{{$ctrl.collapsed}}"
    ng-if="$ctrl.openedOnce()"
    ng-show="$ctrl.showContent()"
    class="content">
    <div class="content-row">
      <div class="content-text">
        <ng-transclude></ng-transclude>
      </div>
    </div>
  </div>
</div>
`;
export default template;
